import React, { Component } from 'react';
import GetTerminos from './modalinformativo/getTerminos';
class getSeleccionLogin extends Component {
  constructor(){
    super();
    this.state = {
        modulo : ''
    }
  }
  getRegresarCondiciones =()=>{
    this.setState({
      modulo:''
    })
  }
  getCondiciones =() =>{
    this.setState({
      modulo:'condiciones'
    })
  }
  render() {
    let dir_modulo_modal
    const modulo = this.state.modulo
    if(modulo==='condiciones'){
      dir_modulo_modal = <div id="loader_msg" className="loader_msg loader_msg-default is-active"  data-text="">
                          <GetTerminos getRegresarCondiciones={this.getRegresarCondiciones} token={this.props.token} dir_url={this.props.dir_url}/>
                          </div>
    }
    let logo
    const uuid_imagen=((this.props.uuid_imagen)+"").trim()
    const url_image = this.props.url_image
    const separator = this.props.separator
    const file_xxx =this.props.file_250x200
    const token_image = url_image+file_xxx+separator
    const ext="_250x200.png?alt=media"
    if(uuid_imagen===''){
      logo="https://www.grupomn.net/app/img/sinfoto.png"
    }else{
      logo=token_image+uuid_imagen+ext
    }
    return (
      <div className="cssversion_menu cssversion_colorprimario ">
          <div className="cssversion_pw100 cssversion_ph40 cssversion_contentCenter">
            <div className="cssversion_colorwhite cssversion_pxw250 cssversion_pxh200 cssversion_contentCenter" style={{"borderRadius": "15px 15px 15px 15px"}}>
              <img className="cssversion_pxw200" alt="Cargando Imagen . . ." src={logo} />
            </div>
          </div>
          <div className="cssversion_pw100 cssversion_ph60 cssversion_colorwhite" style={{"borderRadius": "30px 30px 0px 0px"}}>
            <div className="cssversion_pw100 cssversion_pxh100 cssversion_contentCenter">
              <button className="button-global" onClick={ () => this.props.get_go_to('registre_new')}>
                REGÍSTRATE
              </button>
            </div>

            <div className="cssversion_pw100 cssversion_footer">
              <div className="cssversion_pw100 cssversion_contentCenter">
                <span className="span-global-info cssversion_padding10">Continuar implica que has leído y aceptado los términos, condiciones y políticas.</span>
              </div>
              <div className="cssversion_pw100  cssversion_contentCenter">
                <span className="span-global-link cssversion_padding10" onClick={ () => this.getCondiciones()}>Ver Condiciones</span>
              </div>
            </div>
          </div>
          {dir_modulo_modal}
      </div>
    )
  }
  /*<div className="cssversion_pw100 cssversion_contentCenter">
    <span className="span-global cssversion_padding5">¿Tienes una cuenta?</span>
    <span className="span-global-link cssversion_padding5" onClick={ () => this.props.get_go_to('login_session')}>Iniciar sesión</span>
  </div>*/
  /*<div className="grid colorprimario ph100">
    <div className="col-12">
      <div className="grid ph100">
        <div className="col-2">
        </div>
        <div className="col-8 col-grid centerContent">
          <img className="pxw200" alt="Cargando Imagen . . ." src={logo} />
        </div>
        <div className="col-2">
        </div>
      </div>
    </div>
    <div className="col-12 colorblanco" style={{"borderRadius": "30px 30px 0px 0px"}}>
      <div className="grid">
        <div className="col-12 centerText">
          <button className="button-global" onClick={ () => this.props.get_go_to('registre_new')}>
            REGÍSTRATE
          </button>
        </div>
        <div className="col-12 centerText">
          <div className="grid">
            <div className="col-6 rightText">
              <span className="span-global">¿Tienes una cuenta?</span>
            </div>
            <div className="col-6 leftText">
              <span className="span-global-link" onClick={ () => this.props.get_go_to('login_session')}>Iniciar sesión</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className = "col-12 col-grid colorblanco centerText">
      <div className = "flex-footer">
        <div className="grid">
          <div className="col-12 centerText">
            <span className="span-global-info">Continuar implica que has leído y aceptado los términos, condiciones y políticas.</span>
          </div>
          <div className="col-12 centerText">
            <span className="span-global-link" onClick={ () => this.getCondiciones()}>
              Ver Condiciones
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>*/
}
export default getSeleccionLogin
